/* eslint-disable @next/next/no-img-element */
import * as React from 'react';

import bscImg from './bnb-chain.svg';
import adaImg from './cardano_logo_full.svg';
import ethImg from './ethereum-logo-full.png';
import fantomImg from './fantom.svg';
import dotImg from './polkadot_logo_full.png';
import polyImg from './polygon_logo.png';
import terraImg from './terra.svg';
import suiImg from './sui-full.png';
import arbitrumImg from './arbitrum-full.png';
import baseImg from './base-full.svg';
import zksyncImg from './zksync_full.png';

export function ChainLabel({ chain }: { chain: string }) {
  return (
    {
      ETH: <img src={ethImg.src} alt="Ethereum" className="md:h-7 h-5" />,
      BSC: <img src={bscImg.src} alt="BNB Chain" className="md:h-6 h-5" />,
      DOT: <img src={dotImg.src} alt="Polkadot" className="md:h-6 h-5" />,
      ADA: <img src={adaImg.src} alt="Cardano" className="md:h-6 h-5" />,
      POLY: <img src={polyImg.src} alt="Polygon" className="md:h-6 h-5" />,
      TERRA: <img src={terraImg.src} alt="Terra" className="md:h-6 h-5" />,
      FTM: <img src={fantomImg.src} alt="Fantom" className="md:h-7 h-5" />,
      ARB: (
        <img
          src={arbitrumImg.src}
          alt="Arbitrum"
          className="md:h-9 h-7 bg-white/70 rounded-full pl-2"
        />
      ),
      SUI: <img src={suiImg.src} alt="Sui" className="md:h-7 h-5" />,
      BASE: <img src={baseImg.src} alt="Base" className="md:h-7 h-5" />,
      ZKSYNC: <img src={zksyncImg.src} alt="ZKsync" className="md:h-7 h-5" />,
    }[chain] ?? null
  );
}
